import React from 'react'

import { HeadingLarge, BodyText, FadeIn, Button } from '@pb/components'
import { isAppDevice, isNorthstarBrand } from '@pb/utils'
import cn from 'classnames'

import { EXTERNAL_ROUTES } from 'App/constants'
import triggerExternalModal, { signin } from 'helpers/triggerExternalModal'

import { NonLoggedInProps } from '../../../MyStyleboards/types'
import styles from '../../Following.module.scss'
import { nonLoggedInBtnText, nonLoggedInText, nonLoggedInBodyText } from '../../labels'

const NonLoggedIn: React.FC<NonLoggedInProps> = () => {
  const handleSignIn = (): void => {
    if (isAppDevice()) {
      window.location.href = EXTERNAL_ROUTES.login
    } else if (isNorthstarBrand) {
      const event = new Event('HEADER_OPEN_SIGN_IN_MODAL')
      window.dispatchEvent(event)
    } else {
      triggerExternalModal(signin)
    }
  }

  return (
    <FadeIn>
      <div className={cn(styles.emptyContainer, styles.emptyContainerDefault)}>
        <HeadingLarge Tag="h2" className={styles.emptyText}>
          {nonLoggedInText}
        </HeadingLarge>
        <BodyText className={styles.emptyText}>{nonLoggedInBodyText}</BodyText>
        <Button fullWidth className={styles.nonLoggedInButton} onClick={handleSignIn}>
          {nonLoggedInBtnText}
        </Button>
      </div>
    </FadeIn>
  )
}

export default NonLoggedIn
